import { useEffect, useState } from 'react'
import { toast } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks'
import { getAllStatesProvincesList } from '@user/store/dictionaries'

export function useGetStatesProvinceOnMount() {
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        setStatus('pending')
        const result = await dispatch(getAllStatesProvincesList())

        if (mounted) {
          if (getAllStatesProvincesList.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
            toast.error(`Error: States Province data failed to load`)
          }
        }
      } catch (err) {
        if (mounted) {
          setStatus('fail')
        }
      }
    }

    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}
